import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL || '/api',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const holidayApi = createApi({
  reducerPath: 'holidayApi',
  baseQuery,
  tagTypes: ['Holiday'],
  endpoints: (builder) => ({
    // Get all holidays
    getHolidays: builder.query({
      query: (params) => ({
        url: '/holidays',
        params,
      }),
      providesTags: ['Holiday'],
    }),

    // Get single holiday
    getHoliday: builder.query({
      query: (id) => `/holidays/${id}`,
      providesTags: (result, error, id) => [{ type: 'Holiday', id }],
    }),

    // Create holiday
    createHoliday: builder.mutation({
      query: (holidayData) => ({
        url: '/holidays',
        method: 'POST',
        body: holidayData,
      }),
      invalidatesTags: ['Holiday'],
    }),

    // Update holiday
    updateHoliday: builder.mutation({
      query: ({ id, ...holidayData }) => ({
        url: `/holidays/${id}`,
        method: 'PUT',
        body: holidayData,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Holiday', id }],
    }),

    // Delete holiday
    deleteHoliday: builder.mutation({
      query: (id) => ({
        url: `/holidays/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Holiday'],
    }),

    // Get holidays for calendar
    getHolidaysForCalendar: builder.query({
      query: (params) => ({
        url: '/holidays/calendar',
        params,
      }),
      providesTags: ['Holiday'],
    }),
  }),
});

export const {
  useGetHolidaysQuery,
  useGetHolidayQuery,
  useCreateHolidayMutation,
  useUpdateHolidayMutation,
  useDeleteHolidayMutation,
  useGetHolidaysForCalendarQuery,
} = holidayApi;
